import { getPermissionCode } from '~/utils/route-permission-url'

export default async function (context) {
  // If the user is not authenticated
  if (context.$cookie.get('token')) {
    let currentPageRoute = 'dashboard'
    const userPermissions = context.store.state.settings.userPermissions
    const route = context.route.path

    currentPageRoute = getPermissionCode(route)

    const userData = context.$cookie.get('user')

    if (userData && userData.user_type !== 1) {
      await context.store.dispatch('settings/permissionCode', currentPageRoute) // The save the current route permission code into cookies
      if (userPermissions.length === 0) {
        await context.store.dispatch('settings/userPermissions') // To fetch the user permissions data
      }
    }
  }
}
